import { render, staticRenderFns } from "./PatientSelectList.vue?vue&type=template&id=20d15541&scoped=true"
import script from "./PatientSelectList.vue?vue&type=script&lang=js"
export * from "./PatientSelectList.vue?vue&type=script&lang=js"
import style0 from "./PatientSelectList.vue?vue&type=style&index=0&id=20d15541&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d15541",
  null
  
)

export default component.exports